export default "__VITE_ASSET__$i9HJqJY__"